import clsx from 'clsx';

interface GroupScoreIndicatorAwarenessProps {
  children?: React.ReactNode;
  isScoreWithinBreakpoint: boolean;
}

export function GroupScoreIndicatorAwareness({ isScoreWithinBreakpoint, children }: GroupScoreIndicatorAwarenessProps) {
  return (
    <div
      className={clsx(
        'contents',
        isScoreWithinBreakpoint &&
          '[&_.ScoreHealthRangeGroup-label]:!text-white [&_.ScoreHealthRangeGroup-label]:!font-bold'
      )}
    >
      {children}
    </div>
  );
}
